module.exports = __webpack_public_path__ + "img/restauration.47fca6b8.png";